import { ImagePlus, Save, Trash2 } from "lucide-react";
import { useDropzone } from "react-dropzone";
import ImageDropField from "./ImageDropField";
import { getAssetUrl } from "../lib/api";

export default function GalleryEditor({ images, onAddFiles, onChange, onFileUpload, onSave, saving }) {
  const { getInputProps, getRootProps, isDragActive } = useDropzone({
    accept: { "image/*": [".jpg", ".jpeg", ".png", ".webp"] },
    onDrop: onAddFiles,
  });

  const updateImage = (index, value) => {
    const next = [...images];
    next[index] = value;
    onChange(next);
  };

  const removeImage = (index) => onChange(images.filter((_, current) => current !== index));

  return (
    <div className="catalog-editor" data-testid="admin-gallery-panel">
      <div {...getRootProps()} className={isDragActive ? "gallery-add-zone gallery-add-active" : "gallery-add-zone"} data-testid="gallery-add-dropzone">
        <input {...getInputProps()} data-testid="gallery-add-upload-input" />
        <ImagePlus size={24} />
        <strong>Galeriye fotoğraf bırakın</strong>
        <span>Birden fazla görsel ekleyebilirsiniz</span>
      </div>
      <div className="catalog-editor-grid">
        {images.map((image, index) => (
          <article key={`${image}-${index}`} data-testid={`gallery-editor-item-${index + 1}`}>
            <img src={getAssetUrl(image)} alt={`Galeri görseli ${index + 1}`} data-testid={`gallery-editor-preview-${index + 1}`} />
            <label>Görsel bağlantısı<input value={image} onChange={(event) => updateImage(index, event.target.value)} data-testid={`gallery-image-url-input-${index + 1}`} /></label>
            <ImageDropField image={image} label="Görseli sürükleyin" onFileUpload={(file) => onFileUpload(index, file)} inputTestId={`gallery-image-upload-input-${index + 1}`} rootTestId={`gallery-image-dropzone-${index + 1}`} />
            <button className="gallery-delete-button" onClick={() => removeImage(index)} data-testid={`gallery-image-delete-button-${index + 1}`}><Trash2 size={15} /> Görseli çıkar</button>
          </article>
        ))}
      </div>
      <button onClick={onSave} disabled={saving} className="admin-save" data-testid="save-gallery-button"><Save size={17} /> Galeriyi kaydet</button>
    </div>
  );
}